<template>
    <div style="text-align:left;">
        <a-row>
            <a-button style="margin-top:20px;" type="primary" @click="ShowModalAdd">
                {{ i18n.$t('NormalSettingAddButton') }}
            </a-button>
            <a-modal
                :title="i18n.$t('NormalSettingAddTitle')"
                :width = "600"
                :visible="ModalVisibleAdd"
                :confirm-loading="ConfirmLoadingAdd"
                ok-text="Push"
                @ok="handleOkAdd"
                @cancel="handleCancelAdd"
            >  
                <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
                    <a-form-item :label="i18n.$t('NormalSettingKey')">
                        <a-input v-model:value="NormalSettingAddForm.key" />
                    </a-form-item>
                    <a-form-item :label="i18n.$t('NormalSettingValue')">
                        <a-input v-model:value="NormalSettingAddForm.values" />
                    </a-form-item>
                </a-form>
            </a-modal>
            <a-col :span="24">
                <a-table 
                    bordered
                    @change="handleTableChange"
                    :data-source="NormalSettingData"
                    :pagination="pagination"
                    :loading="loading"
                    :columns="columns"
                    :row-key="record => record.key"
                    :scroll="{ x: 1040 }">
                    <template #operation="{ record }">
                        <a-button type="primary" @click="ShowModalEdit(record)">{{ i18n.$t('NormalSettingTabelEdit') }}</a-button><br>
                        <a-popconfirm
                            v-if="NormalSettingData.length"
                            title="Sure to delete?"
                            @confirm="onDelete(record.key)"
                        >
                            <a-button style="margin-top:5px;" type="danger">{{ i18n.$t('NormalSettingTabelDelete') }}</a-button>
                        </a-popconfirm>
                    </template>
                </a-table>
            </a-col>
            <a-modal
                :title="i18n.$t('NormalSettingEditTitle')"
                :width = "600"
                :visible="ModalVisibleEdit"
                :confirm-loading="ConfirmLoadingEdit"
                ok-text="Push"
                @ok="handleOkEdit"
                @cancel="handleCancelEdit"
            >  
                <a-form :label-col="labelCol" :wrapper-col="wrapperCol">
                    <a-form-item :label="i18n.$t('NormalSettingKey')">
                        <a-input v-model:value="NormalSettingEditForm.key" />
                    </a-form-item>
                    <a-form-item :label="i18n.$t('NormalSettingValue')">
                        <a-input v-model:value="NormalSettingEditForm.values" />
                    </a-form-item>
                </a-form>
            </a-modal>
        </a-row>
    </div>
</template>

<script>
    import { useI18n } from "@/i18nPlugin";
    import { defineComponent, ref } from "vue";
    import { message } from 'ant-design-vue'
    import { 
        SearchNormalSettingData,
        AddNormalSettingData,
        EditNormalSettingManageData,
        DeleteNormalSettingData
    } from '../api/index';
    export default defineComponent({
        setup() {
            const i18n = useI18n();
            const token = localStorage.getItem("userToken");
            const columns =  ref([
                {
                    title: i18n.$t('NormalSettingKey'),
                    width: 300,
                    dataIndex: 'key',
                },
                {
                    title: i18n.$t('NormalSettingValue'),
                    width: 300,
                    dataIndex: 'values',
                },
                {
                    title: i18n.$t('NormalSettingOperation'),
                    dataIndex: 'operation',
                    width: 100,
                    slots: { customRender: 'operation' },
                },
            ]);
            let NormalSettingData =  ref([]);
            const pagination =  ref({
                total: 0,
                current: 1,
                pageSize: 10
            });
            const loading =  ref(false);
            const getNormalSetting = (currentPage,pageSize) => {
                SearchNormalSettingData ({
                    currentPage: currentPage,
                    pageSize: pageSize
                },token).then(res => {   
                    NormalSettingData.value = res.data;
                    pagination.value.total = res.total;
                }).catch(error => console.log(error));
            };
            const handleTableChange = (pag) => {
                console.log(pag)  //current   pageSize
                pagination.value.current = pag.current;
                pagination.value.pageSize = pag.pageSize;
                getNormalSetting(pag.current,pag.pageSize);
            }
            const labelCol= ref({ span: 4 })
            const wrapperCol= ref({ span: 14 })
            //添加
            const ShowModalAdd = () => {
                ModalVisibleAdd.value = true;
            }
            const ModalVisibleAdd = ref(false);
            const ConfirmLoadingAdd = ref(false);
            const NormalSettingAddForm = ref({
                key: "",
                values: "",
            });
            const handleOkAdd = () => {
                ConfirmLoadingAdd.value = true;
                // console.log(NormalSettingAddForm._rawValue)
                AddNormalSettingData (NormalSettingAddForm._rawValue,token).then(res => {
                    if(res.status == 200){
                        // this.$message.success('添加成功');
                        ConfirmLoadingAdd.value = false;
                        ModalVisibleAdd.value = false;
                        getNormalSetting(1,10);
                        NormalSettingAddForm.value.key = "";
                        NormalSettingAddForm.value.values = "";
                        // console.log(res)
                    }else {
                        ConfirmLoadingAdd.value = false;
                    }
                }).catch(error => {
                    ConfirmLoadingAdd.value = false;
                    console.log(error);
                })
            }
            const handleCancelAdd = () => {
                ModalVisibleAdd.value = false;
            }
            //编辑
            const NormalSettingEditForm = ref({
                id: "",
                key: "",
                values: "",
            });
            const ModalVisibleEdit = ref(false);
            const ConfirmLoadingEdit = ref(false);
            const ShowModalEdit = (record) => {
                NormalSettingEditForm.value.id = record.id
                NormalSettingEditForm.value.key = record.key
                NormalSettingEditForm.value.values = record.values
                ModalVisibleEdit.value = true;
            }
            const handleOkEdit = () => {
                ConfirmLoadingEdit.value = true;
                EditNormalSettingManageData (NormalSettingEditForm._rawValue,token).then(res => {
                    if(res.status == 200){
                        // this.$message.success('添加成功');
                        ConfirmLoadingEdit.value = false;
                        ModalVisibleEdit.value = false;
                        getNormalSetting(pagination.value.current,pagination.value.pageSize);
                        // console.log(res)
                    }else {
                        ConfirmLoadingEdit.value = false;
                    }
                }).catch(error => {
                    // this.$message.danger('添加失败');
                    ConfirmLoadingEdit.value = false;
                    console.log(error);
                })
            }
            const handleCancelEdit = () => {
                ModalVisibleEdit.value = false;
            }
            //删除
            const onDelete = (key) => {
                DeleteNormalSettingData ({
                    key: key
                },token).then(res => {
                    if(res.status == 200){
                        const TempNormalSettingData = [...NormalSettingData.value];
                        NormalSettingData.value = TempNormalSettingData.filter(item => item.key !== key);
                    }
                }).catch(error => {
                    // this.$message.danger('添加失败');
                    console.log(error);
                })
            }




            return {
                i18n,
                token,
                getNormalSetting,
                pagination,
                loading,
                columns,
                handleTableChange,
                NormalSettingData,
                ShowModalAdd,
                ModalVisibleAdd,
                ConfirmLoadingAdd,
                labelCol,
                wrapperCol,
                NormalSettingAddForm,
                handleOkAdd,
                handleCancelAdd,
                NormalSettingEditForm,
                ModalVisibleEdit,
                ConfirmLoadingEdit,
                ShowModalEdit,
                handleOkEdit,
                handleCancelEdit,
                onDelete,
            }
        },
        mounted() {
            this.getNormalSetting(1,10);
        }
    })
</script>

<style scoped>

</style>